import type { ClawV1Session } from '../../types';

type SessionUnreadArgs = {
  activeSessionId: string | null;
  session: Pick<ClawV1Session, 'id' | 'unread_count' | 'active_task_count' | 'has_active_coordinator_phase'>;
};

export const shouldShowSessionUnreadDot = ({ activeSessionId, session }: SessionUnreadArgs) =>
  session.id !== activeSessionId &&
  !(session.has_active_coordinator_phase ?? false) &&
  (session.active_task_count ?? 0) === 0 &&
  (session.unread_count ?? 0) > 0;

export const shouldShowSessionLoadingDot = ({ activeSessionId, session }: SessionUnreadArgs) =>
  session.id !== activeSessionId &&
  ((session.active_task_count ?? 0) > 0 || (session.has_active_coordinator_phase ?? false));
